module.exports = __webpack_public_path__ + "media/images/icon-check-small-b28b0a2d85f5030ca25096b353d917ec.svg";